module.exports = __webpack_public_path__ + "static/media/no-data.9676408b.png";